import { getMessage } from '@shared/utils';
import { roleNameAlreadyExists } from '@shared/services/api/rolesService';
import * as yup from 'yup';

const roleNameDuplicateMessage = 'El nombre del rol ya existe';

const roleNameBase = () =>
  yup
    .string()
    .matches(/^[^-\s][A-Za-zñÑ ]*[^\s]$/, getMessage('enterValidName'))
    .required(getMessage('requiredField'))
    .min(3, getMessage('minLength').replace('$1', String(3)))
    .max(40, getMessage('maxLength').replace('$1', String(40)));

export const schemaCreateRole = yup.object().shape({
  role_name: roleNameBase().test('checkDuplUsername', roleNameDuplicateMessage, async (value) => {
    const result = await roleNameAlreadyExists(value);
    return !result.data.exists;
  }),
});

export const schemaUpdateRole = (prevRoleName: string) =>
  yup.object().shape({
    role_name: roleNameBase().test('checkDuplUsername', roleNameDuplicateMessage, async (value) => {
      if (value === prevRoleName) return true;
      const result = await roleNameAlreadyExists(value);
      return !result.data.exists;
    }),
  });
